import { HttpService } from './http.service';
import { SpringPage, TableQuery } from '../../shared/models/table-column.model';

export abstract class BaseService<T> {
  constructor(
    protected readonly http: HttpService,
    protected readonly resourcePath: string,
  ) {}

  findById(id: number | string): Promise<T> {
    return this.http.get<T>(`${this.resourcePath}/${id}`);
  }

  save(body: Partial<T>): Promise<T> {
    return this.http.post<T>(this.resourcePath, body);
  }

  update(id: number | string, body: Partial<T>): Promise<T> {
    return this.http.put<T>(`${this.resourcePath}/${id}`, body);
  }

  patch(id: number | string, body: Partial<T>): Promise<T> {
    return this.http.patch<T>(`${this.resourcePath}/${id}`, body);
  }

  delete(id: number | string): Promise<void> {
    return this.http.delete<void>(`${this.resourcePath}/${id}`);
  }

  put(id: number | string, body: Partial<T>): Promise<T> {
    return this.http.put<T>(`${this.resourcePath}/${id}`, body);
  }

  search(query: TableQuery): Promise<SpringPage<T>> {
    const params: Record<string, string | number | boolean> = {
      page: query.page,
      size: query.size,
      sortBy: query.sortBy,
      sortDir: query.sortDir,
    };
    if (query.q) params['q'] = query.q;
    // Filters the server reads directly, outside RSQL (FilterConfig.raw).
    Object.assign(params, query.params ?? {});
    return this.http
      .get<SpringPage<T>>(`${this.resourcePath}/search`, params)
      .then((page) => page ?? { content: [], totalElements: 0, totalPages: 0, size: query.size, number: query.page });
  }
}
